module.exports = __webpack_public_path__ + "media/Dotkit-ShiftStates.3ed57d93.mp4";